import type { LocationChangeAction } from 'connected-react-router'
import type { Location } from 'history'

export interface LocationState {
	current: Location | null
	history: Location[]
}

const initialState: LocationState = {
	current: null,
	history: [],
}

const MAX_HISTORY_LENGTH = 20

export default function locationReducer(
	state = initialState,
	action: LocationChangeAction,
): LocationState {
	if (action.type === '@@router/LOCATION_CHANGE') {
		const nextLocation = action.payload.location as Location
		const current = state.current
		const lastInHistory = state.history[state.history.length - 1]

		const isBackNavigation =
			lastInHistory &&
			lastInHistory.pathname === nextLocation.pathname &&
			lastInHistory.search === nextLocation.search &&
			lastInHistory.hash === nextLocation.hash

		if (isBackNavigation) {
			return {
				current: nextLocation,
				history: state.history.slice(0, -1),
			}
		}

		const updatedHistory =
			current != null
				? [...state.history, current].slice(-MAX_HISTORY_LENGTH)
				: state.history

		return {
			current: nextLocation,
			history: updatedHistory,
		}
	}

	return state
}
